export enum DimensionFieldsEnum {
  PIECES = "numOfItems",
  LENGTH = "dimensionLength",
  WIDTH = "dimensionWidth",
  HEIGHT = "dimensionHeight",
  WEIGHT = "weight",
}
